<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{$t($route.meta.title)}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add
                                v-if="hasPerm('shipments.create')"
                                @invoke-method="invokeMethod($event)"
                                action="showShipment"
                            ></bc-btn-add>
                            <bc-btn-refresh
                                @invoke-method="dbGetShipments()"
                            ></bc-btn-refresh>
                            <bc-search-menu
                                :params="axiosParams"

                            >
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input
                                            v-model="filter.search"
                                            :params="axiosParams"
                                        ></bc-search-input>
                                    </v-list-tile>

                                    <v-divider></v-divider>

                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav
                                @invoke-method="invokeMethod($event)"
                                :mobile-list="mobile_list"
                            ></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table
                        :headers="headers"
                        :items="shipments"
                        :no-data-text="$t('lang.no_results_matching')"
                        hide-actions
                    >
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="showShipment(props.item)">
								<td>{{ props.item.sold_address_id }}</td>
								<td>{{ props.item.ship_address_id }}</td>
								<td>{{ props.item.date_shipped }}</td>
								<td>{{ props.item.carrier }}</td>
								<td>{{ props.item.notes }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination
                        :page="page"
                        :params="axiosParams"
                        name="shipment"
                    ></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="shipment_dialog">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ currObjField('shipment_id') ? $t('lang.edit_shipment') : $t('lang.add_shipment') }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            action="closeShipmentDialog"
                            :dialog-status="shipment_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="shipment">
                            <v-container grid-list-form>
                                <v-layout row wrap>
									<v-flex xs12>
										<bc-autocomplete
											:focus="shipment_dialog"
											v-model="shipment.sold_address_id"
											:label="$t('lang.sold_address_id')"
											:items="[]"
											item-value="value"
											item-text="text"
											:rules="ifValid('shipment.sold_address_id')"
										></bc-autocomplete>
									</v-flex>
									<v-flex xs12>
										<bc-autocomplete
											v-model="shipment.ship_address_id"
											:label="$t('lang.ship_address_id')"
											:items="[]"
											item-value="value"
											item-text="text"
											:rules="ifValid('shipment.ship_address_id')"
										></bc-autocomplete>
									</v-flex>
									<v-flex xs12>
										<bc-date-picker
											v-model="shipment.date_shipped"
											:label="$t('lang.date_shipped')"
											:rules="ifValid('shipment.date_shipped')"
										></bc-date-picker>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											v-model="shipment.carrier_id"
											:label="$t('lang.carrier_id')"
											:counter="showCounter(shipment.carrier_id, 'shipment.carrier_id')"
											:rules="ifValid('shipment.carrier_id')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<v-textarea
											v-model="shipment.notes"
											:label="$t('lang.notes')"
											auto-grow
											rows="1"
											:rules="ifValid('shipment.notes')"
										></v-textarea>
									</v-flex>

                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn v-if="currObjField('shipment_id')" color="error" @mouseup.left="$refs.delete_shipment.openDialog()">{{ $t('lang.delete') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="closeShipmentDialog()">{{$t('lang.cancel')}}</v-btn>
                        <v-btn color="success" @mouseup.left="modifyShipment(currObjField('shipment_id') ? 'patch' : 'post', currObjField('shipment_id'))">{{$t('lang.save')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_shipment"
                :heading="$t('lang.delete_shipment')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="modifyShipment('delete', currObjField('shipment_id'))"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            headers: [
                { text: this.$t("lang.sold_address_id"), sortable: false, width: "20%" },
                { text: this.$t("lang.ship_address_id"), sortable: false, width: "20%" },
                { text: this.$t("lang.date_shipped"), sortable: false, width: "20%" },
                { text: this.$t("lang.carrier_id"), sortable: false, width: "20%" },
                { text: this.$t("lang.notes"), sortable: false, width: "20%" },
            ],

            shipment: {
                sold_address_id: "",
                ship_address_id: "",
                date_shipped: "",
                carrier_id: "",
                notes: "",
            },
            current_obj: null,
            filter: {
                search: "",

                page_size: 0,
                page_num: 0,
            },
            shipment_dialog: false,
            mobile_list: [{ title: this.$t("lang.add_new"), action: "showShipment" }, { title: this.$t("lang.refresh"), action: "dbGetShipments" }],
            dbGetShipments: _.debounce(this.getShipments, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchShipment", {
                url: "shipments",
                method: "get",
                stateProperty: "shipments",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.shipments) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.$store
            .dispatch("fetchShipment", {
                url: "shipments",
                method: "get",
                stateProperty: "shipments",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.shipments) {
                    this.setQuery(parsedQuery, this.filter, this.default_filter);
                    this.finishLoader();
                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    computed: {
        ...mapState({
            rules_shipment: (state) => state.validation.rules_shipment,
            default_filter: (state) => state.shipment.shipments_filter,
            page: (state) => state.shipment.page,
            shipments: (state) => state.shipment.shipments,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
        currObjField() {
            return (field) => {
                return this.current_obj && field && this.current_obj[field] ? this.current_obj[field] : "";
            };
        },
    },
    methods: {
        closeShipmentDialog() {
            this.shipment_dialog = false;
            this.$refs.delete_shipment.close();
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        getShipments() {
            this.startLoader();
            this.$store
                .dispatch("fetchShipment", {
                    url: "shipments",
                    method: "get",
                    stateProperty: "shipments",
                    commit: true,
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.shipment_dialog = false;
                    this.$store.commit("toggleModalLoader", false);
                    this.$store.commit("validationOff");
                    this.finishLoader(true);
                });
        },

        modifyShipment(method = null, id = null) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("shipment")) {
                        this.$store.commit("toggleModalLoader", true);
                        this.$store
                            .dispatch("fetchShipment", {
                                pk: "shipment_id",
                                id: id,
                                url: `shipments/${id ? id : ""}`,
                                method: method,
                                stateProperty: "shipments",
                                mutate: true,
                                body: this.shipment,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.closeShipmentDialog();
                                } else {
                                    this.$store.commit("toggleModalLoader", false);
                                }
                            });
                    }
                });
            }
        },
        showShipment(item = null) {
            this.current_obj = item;

            if (this.$refs.shipment) item ? this.$refs.shipment.resetValidation() : this.$refs.shipment.reset();

            this.$nextTick(() => {
                this.assignObj(this.shipment, item, this.rules_shipment);
                this.shipment_dialog = true;
            });
        },
    },
};
</script>
